module.exports = __webpack_public_path__ + "assets/children-selected.290febb1e93f2260875f59c653a586c5.svg";